module.exports = __webpack_public_path__ + "img/cbr-assign-user.6597b815.svg";